

export class TourByBranchIdDataOutput implements ITourByBranchIdDataOutput {
    /** The auto-generated id of the tour master */
    tour_id!: number;
    /** The tour name 255 character limit */
    tour_name!: string;

    constructor(data?: ITourByBranchIdDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tour_id = _data["tour_id"];
            this.tour_name = _data["tour_name"];
        }
    }

    static fromJS(data: any): TourByBranchIdDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TourByBranchIdDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tour_id"] = this.tour_id;
        data["tour_name"] = this.tour_name;
        return data; 
    }
}

export interface ITourByBranchIdDataOutput {
    /** The auto-generated id of the tour master */
    tour_id: number;
    /** The tour name 255 character limit */
    tour_name: string;
}

